import React from "react"
import { styled } from "@mui/material/styles"
import { css } from "@emotion/react"
import { timeAgoInWords } from "../utils/stringUtils"
import { Avatar, Grid, IconButton, Link, ListItemAvatar } from "@mui/material"
import ConfirmationPopover from "./ConfirmationPopover"
import ThemeProviderWrapper from "./ThemeProviderWrapper"

const ReplyContainer = styled("div")(
  ({ isHighlighted }) => css`
    padding: 3px 0px 3px 10px;
    position: relative;
    background-color: ${isHighlighted ? "#f2f2f2" : "transparent"};
    border-radius: 5px;
    margin-top: 5px;
  `
)

const ReplyTimestamp = styled("p")`
  font-size: 11px;
  display: inline;
  margin-left: 8px;
  color: #c0c0c0;
`

const ActionIcon = styled("i")`
  font-size: 11px;
  margin: 0 3px;
`

const SFLink = styled(Link)`
  text-decoration: none;
  color: #333333;
`

const CardAvatar = styled(Avatar)`
  width: 20px;
  height: 20px;
`

const HeaderGrid = styled(Grid)`
  align-items: center;
`

const UsernameGrid = styled(Grid)`
  font-size: 15px;
  text-align: left;
`

const ActionGrid = styled(Grid)`
  padding-right: 5px;
  text-align: right;
`

const SFIconButton = styled(IconButton)`
  border-radius: 10%;
  width: 20px;
  height: 20px;
`

const ReplyBody = styled(Grid)`
  text-align: left;
  word-wrap: break-word;
  padding: 5px 7px 5px 0;
`

export default class ReplyCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      popoverAnchorEl: null,
      commentToDelete: null,
    }
  }

  openPopover = (event, commentId) => {
    this.setState({
      popoverAnchorEl: event.currentTarget,
      commentToDelete: commentId,
    })
  }

  closePopover = () => {
    this.setState({ popoverAnchorEl: null, commentToDelete: null })
  }

  confirmDelete = () => {
    const { commentToDelete } = this.state
    if (commentToDelete) {
      this.props.handleDeleteComment(commentToDelete)
    }
    this.closePopover()
  }

  render() {
    const { reply, currentUser, isHighlighted } = this.props
    const { popoverAnchorEl } = this.state
    const popoverOpen = Boolean(popoverAnchorEl)

    return (
      <ReplyContainer isHighlighted={isHighlighted}>
        <ThemeProviderWrapper>
          <HeaderGrid container spacing={1}>
            <Grid item xs={1}>
              <ListItemAvatar>
                <SFLink href={reply.commentor_user_url}>
                  <CardAvatar
                    src={reply.commentor_user_avatar}
                    alt={reply.commentor_user_avatar}
                  />
                </SFLink>
              </ListItemAvatar>
            </Grid>
            <UsernameGrid item xs={9}>
              <SFLink href={reply.commentor_user_url}>
                <strong>{reply.commentor_user_name}</strong>
              </SFLink>
              <ReplyTimestamp>
                {timeAgoInWords(reply.created_at)}
              </ReplyTimestamp>
            </UsernameGrid>
            <ActionGrid item xs={2}>
              {(currentUser?.slug === reply.commentor_slug ||
                currentUser?.can_moderate === true) && (
                <>
                  <SFIconButton
                    onClick={(event) => this.openPopover(event, reply.id)}
                  >
                    <ActionIcon className="far fa-trash-can" aria-hidden="true" />
                  </SFIconButton>
                  <ConfirmationPopover
                    anchorEl={popoverAnchorEl}
                    open={popoverOpen}
                    onClose={this.closePopover}
                    onConfirm={this.confirmDelete}
                    message="Are you sure you want to delete this reply?"
                  />
                </>
              )}
            </ActionGrid>
          </HeaderGrid>
          <ReplyBody item xs={11}>
            {reply.body}
          </ReplyBody>
        </ThemeProviderWrapper>
      </ReplyContainer>
    )
  }
}
